module.exports = __webpack_public_path__ + "assets/img/9_393.62810add.jpg";